<template>
  <div class="elevatoer-container">
    <div class="returnScence" @click="returnScence"></div>
    <div class="equ-elevator">
      <equ-num :evaData="evaData"></equ-num>
      <!-- <equ-mior></equ-mior> -->
    </div>
    <div class="dialog" v-show="isShowDialog">
      <pannel-box :headerName="'电梯'" :headerData="headerData">
        <div class="detail-box">
          <div
            class="contentList"
            v-for="(item, key, index) in monitorList"
            :key="index"
          >
            <div class="text">{{ key }}</div>
            <div class="value">
              {{ item.value == "暂无数据" ? "--" : item.value }}
            </div>
          </div>
        </div>
      </pannel-box>
    </div>
  </div>
</template>

<script>
import equNum from "./components/equ-num.vue";
import EquMior from "./components/equ-mior.vue";
import { getElevatorData, getEqpInfo } from "@/api/index.js";
import bus from "@/components/three-scene/Bus.js";
import EquDialog from "./components/equ-dialog.vue";
export default {
  components: { equNum, EquMior, EquDialog },
  mounted() {
    this.$store.state.threeEvent.intoElevator = true;
    bus.emit("lift", true);
    bus.on("dialogNumber", this.ReqEqpInfo);
  },
  data() {
    return {
      isShowDialog: false,
      evaData: [],
      timer: null,
      headerData: {},
      monitorList: {},
    };
  },
  created() {
    this.getEvaData();
    this.timer = setInterval(() => {
      this.getEvaData();
    }, 1000);
  },
  methods: {
    returnScence() {
      bus.emit("back");
      this.isShowDialog = false;
    },
    getRadom() {
      return arguments[Math.floor(Math.random * arguments.length)];
    },
    async getEvaData() {
      let { data: res } = await getElevatorData();
      this.evaData = res.count;
      let { collectionValue } = res;
      collectionValue.map((item) => {
        bus.emit(
          "liftMove",
          item.eqpCode,
          item.data.运行状态.value,
          item.data.楼层.value,
          item.status
        );
      });
    },
    async ReqEqpInfo(eqpCode) {
      let { data: res } = await getEqpInfo({ eqpCode });
      this.headerData = res.baseData;
      this.monitorList = res.collectionValue.data;
      this.isShowDialog = true;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<!-- 电梯 -->
<style lang="scss" scoped>
.returnScence {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.equ-elevator {
  position: absolute;
  left: 107px;
  top: 135px;
  width: 416px;
}
.dialog {
  position: absolute;
  top: 135px;
  right: 43px;
  width: 416px;
}
</style>
